import { addQuizProgress, addStoryProgress, finishVideo, unlockVideo } from '../fetching/fetchingUser';

export const handleQuizProgress = (subtopicId, token, quizProgress, setQuizProgress, isLoggedIn, userId) => {
    addQuizProgress(token, subtopicId, userId).then(
        response => {
            let updatedProgress = handleQuizStateUpdate(quizProgress, response);
            setQuizProgress(updatedProgress)
            if (!isLoggedIn) {
                localStorage.setItem("localQuizProgress", JSON.stringify(updatedProgress));
            }
        }
    );
}

export const handleStoryProgress = (
    substoryId, token, storyProgress, 
    setStoryProgress, isLoggedIn, 
    relevant, identifier, bestAnswer) => {
        if (relevant) {
            addStoryProgress(token, substoryId, identifier, bestAnswer).then(
                response => {
                    let updatedProgress = handleStoryStateUpdate(storyProgress, response);
                    setStoryProgress(updatedProgress)
                    if (!isLoggedIn) {
                        localStorage.setItem("localStoryProgress", JSON.stringify(updatedProgress));
                    }
                }
            );
        }
    }

export const handleVideoFinished = (videoId, token, videoProgress, setVideoProgress, isLoggedIn) => {
    finishVideo(token, videoId).then(
        response => {
            let updatedProgress = handleVideoStateUpdate(videoProgress, response);
            setVideoProgress(updatedProgress)
            if (!isLoggedIn) {
                localStorage.setItem("localVideoProgress", JSON.stringify(updatedProgress));
            }
        }
    );
}

export const handleVideoUnlocked = (videoId, token, videoProgress, setVideoProgress, isLoggedIn) => {
    unlockVideo(token, videoId).then(
        response => {
            let updatedProgress = handleVideoStateUpdate(videoProgress, response);
            setVideoProgress(updatedProgress)
            if (!isLoggedIn) {
                localStorage.setItem("localVideoProgress", JSON.stringify(updatedProgress));
            }
        }
    );
}

export const fetchProgress = (token, setProgress, isLoggedIn, lsKeyWord, fetchFunction) => {
    if (isLoggedIn && token) {
        fetchFunction(token).then(
            result => {
                setProgress(result);
            }
        )
    } else {
        let localProgress = JSON.parse(localStorage.getItem(lsKeyWord));
        setProgress(localProgress ? localProgress : []);
    }
}

const handleStoryStateUpdate = (progress, response) => {
    let existsYet = false;
    let updatedProgress = progress.reduce(
        (prev_output, value) => {
            if (value.id === response.id) {
                existsYet = true;
                prev_output.push(response);
            } else {
                if (value.storyId !== response.storyId) {
                    prev_output.push(value);
                }
            }
            return prev_output
        }, []
    )
    if (!existsYet) {
        updatedProgress = [...progress, response];
    }
    return updatedProgress;
}

const handleVideoStateUpdate = (progress, response) => {
    let existsYet = false;
    let updatedProgress = progress.reduce(
        (prev_output, value) => {
            if (value.id === response.id) {
                existsYet = true;
                prev_output.push(response);
            } else {
                if (value.videoId !== response.videoId) {
                    prev_output.push(value);
                }
            }
            return prev_output
        }, []
    )
    if (!existsYet) {
        updatedProgress = [...progress, response];
    }
    return updatedProgress;
}

const handleQuizStateUpdate = (progress, response) => {
    let existsYet = false;
    let updatedProgress = progress.reduce(
        (prev_output, value) => {
            if (value.id === response.id) {
                existsYet = true;
                prev_output.push(response);
            } else {
                if (value.subtopicId !== response.subtopicId) {
                    prev_output.push(value);
                }
            }
            return prev_output
        }, []
    )
    if (!existsYet) {
        updatedProgress = [...progress, response];
    }
    return updatedProgress;
}
